import moment from "moment";
import React, { useContext, useEffect, useMemo, useState } from "react";
import AllStateContext from "../../context/allstateContext";
import { FILTER_TYPE } from "../../Constant/constant";
import MothFilterDialog from "../../Common/MothFilterDialog";

const DateView = ({ totalExpense, totalIncome, dateUpdate }) => {
  const {
    setOpen,
    setRecordItem,
    startEndDate,
    setStartEndDate,
    setOpenMonthFilterDialog,
    selectedFilterType,
    resetFilter,
    setResetFilter,
    openMonthFilterDialog,
  } = useContext(AllStateContext);

  const dateSwitcher = (count) => {
    let currentDate;
    if (!startEndDate.startDate) {
      setStartEndDate({ startDate: new Date() });
      currentDate = new Date();
    } else {
      currentDate = new Date(startEndDate.startDate);
    }
    let counter = 0;
    if (count === "+") {
      if (selectedFilterType === FILTER_TYPE.MONTH_3) {
        counter = FILTER_TYPE.MONTH_3;
      } else if (selectedFilterType === FILTER_TYPE.MONTH_6) {
        counter = FILTER_TYPE.MONTH_6;
      } else if (selectedFilterType === FILTER_TYPE.YEARLY) {
        counter = FILTER_TYPE.YEARLY;
      } else {
        counter = 1;
      }
    }
    if (count === "-") {
      if (selectedFilterType === FILTER_TYPE.MONTH_3) {
        counter = -FILTER_TYPE.MONTH_3;
      } else if (selectedFilterType === FILTER_TYPE.MONTH_6) {
        counter = -FILTER_TYPE.MONTH_6;
      } else if (selectedFilterType === FILTER_TYPE.YEARLY) {
        counter = -FILTER_TYPE.YEARLY;
      } else {
        counter = -1;
      }
    }
    if (counter != 0) {
      currentDate.setMonth(currentDate.getMonth() + counter);

      counter = Math.abs(counter);
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();

      const startDate = new Date(currentYear, currentMonth, counter);
      const endDate = new Date(currentYear, currentMonth + counter, 0);
      endDate.setHours(23, 59, 59, 999);
      startDate.setHours(0, 0, 0, 0);
      setStartEndDate({ startDate, endDate });
    } else {
      if (selectedFilterType === FILTER_TYPE.MONTH_3) {
        counter = FILTER_TYPE.MONTH_3;
      } else if (selectedFilterType === FILTER_TYPE.MONTH_6) {
        counter = FILTER_TYPE.MONTH_6;
      } else if (selectedFilterType === FILTER_TYPE.YEARLY) {
        counter = FILTER_TYPE.YEARLY;
      }
      currentDate.setMonth(currentDate.getMonth());

      counter = Math.abs(counter);
      if (counter === 0) {
        counter = 1;
      }
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();

      const startDate = new Date(currentYear, currentMonth);
      const endDate = new Date(currentYear, currentMonth + counter, 0);
      endDate.setHours(23, 59, 59, 999);
      startDate.setHours(0, 0, 0, 0);
      setStartEndDate({ startDate, endDate });
    }
  };
  useMemo(() => {
    if (resetFilter) {
      setResetFilter(false);
      dateSwitcher("");
    }
  }, [resetFilter]);

  return (
    <div className="glass-card mb-3" style={{ padding: "16px", marginTop: "80px" }}>
      {openMonthFilterDialog && <MothFilterDialog />}
      
      {/* Date Switcher Row */}
      <div 
        className="d-flex align-items-center justify-content-between mb-3 pb-3"
        style={{ borderBottom: "1px solid var(--border-color)" }}
      >
        <button
          onClick={() => dateSwitcher("-")}
          className="btn btn-secondary d-flex align-items-center justify-content-center"
          style={{
            width: "36px",
            height: "36px",
            borderRadius: "50%",
            padding: "0",
            minWidth: "36px",
            background: "var(--bg-surface-hover)",
            borderColor: "var(--border-color)"
          }}
        >
          <img
            style={{ height: "16px", width: "16px", filter: "invert(1)" }}
            src={require("../../Common/Icon/left-arrow.png")}
            alt="left-arrow"
          />
        </button>

        <div 
          style={{ 
            fontSize: "1.05rem", 
            fontWeight: "700", 
            color: "var(--text-primary)",
            letterSpacing: "0.02em"
          }}
        >
          {`${moment(startEndDate.startDate).format("DD MMM, YYYY")} - ${moment(startEndDate.endDate).format("DD MMM, YYYY")}`}
        </div>

        <div className="d-flex align-items-center gap-2">
          <button
            onClick={() => dateSwitcher("+")}
            className="btn btn-secondary d-flex align-items-center justify-content-center"
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              padding: "0",
              minWidth: "36px",
              background: "var(--bg-surface-hover)",
              borderColor: "var(--border-color)"
            }}
          >
            <img
              style={{ height: "16px", width: "16px", filter: "invert(1)" }}
              src={require("../../Common/Icon/right-arrow.png")}
              alt="right-arrow"
            />
          </button>
          
          <button
            onClick={() => setOpenMonthFilterDialog(true)}
            className="btn btn-secondary d-flex align-items-center justify-content-center"
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              padding: "0",
              minWidth: "36px",
              background: "rgba(99, 102, 241, 0.1)",
              borderColor: "rgba(99, 102, 241, 0.2)"
            }}
          >
            <img
              style={{ height: "16px", width: "16px", filter: "invert(1)" }}
              src={require("../../Common/Icon/menu-bar.png")}
              alt="menu-bar"
            />
          </button>
        </div>
      </div>

      {/* Summary Cards Grid */}
      <div className="row g-2">
        {/* Expense Card */}
        <div className="col-12 col-md-4">
          <div 
            style={{
              background: "rgba(239, 68, 68, 0.02)",
              border: "1px solid rgba(239, 68, 68, 0.08)",
              borderLeft: "3px solid var(--danger)",
              borderRadius: "10px",
              padding: "10px 14px"
            }}
          >
            <div style={{ fontSize: "0.78rem", fontWeight: "600", color: "var(--text-secondary)", letterSpacing: "0.05em", textTransform: "uppercase" }}>
              Total Expense
            </div>
            <div style={{ fontSize: "1.35rem", fontWeight: "800", color: "var(--danger)", marginTop: "2px" }}>
              {`₹${totalExpense ? totalExpense.toLocaleString("en-IN") : 0}`}
            </div>
          </div>
        </div>

        {/* Income Card */}
        <div className="col-12 col-md-4">
          <div 
            style={{
              background: "rgba(16, 185, 129, 0.02)",
              border: "1px solid rgba(16, 185, 129, 0.08)",
              borderLeft: "3px solid var(--success)",
              borderRadius: "10px",
              padding: "10px 14px"
            }}
          >
            <div style={{ fontSize: "0.78rem", fontWeight: "600", color: "var(--text-secondary)", letterSpacing: "0.05em", textTransform: "uppercase" }}>
              Total Income
            </div>
            <div style={{ fontSize: "1.35rem", fontWeight: "800", color: "var(--success)", marginTop: "2px" }}>
              {`₹${totalIncome ? totalIncome.toLocaleString("en-IN") : 0}`}
            </div>
          </div>
        </div>

        {/* Net Balance Card */}
        <div className="col-12 col-md-4">
          {(() => {
            const balance = (totalIncome - totalExpense) || 0;
            const isNegative = balance < 0;
            return (
              <div 
                style={{
                  background: isNegative ? "rgba(239, 68, 68, 0.02)" : "rgba(99, 102, 241, 0.02)",
                  border: "1px solid " + (isNegative ? "rgba(239, 68, 68, 0.08)" : "rgba(99, 102, 241, 0.08)"),
                  borderLeft: "3px solid " + (isNegative ? "var(--danger)" : "var(--primary)"),
                  borderRadius: "10px",
                  padding: "10px 14px"
                }}
              >
                <div style={{ fontSize: "0.78rem", fontWeight: "600", color: "var(--text-secondary)", letterSpacing: "0.05em", textTransform: "uppercase" }}>
                  Net Balance
                </div>
                <div style={{ fontSize: "1.35rem", fontWeight: "800", color: isNegative ? "var(--danger)" : "var(--text-primary)", marginTop: "2px" }}>
                  {isNegative ? `-₹${Math.abs(balance).toLocaleString("en-IN")}` : `₹${balance.toLocaleString("en-IN")}`}
                </div>
              </div>
            );
          })()}
        </div>
      </div>
    </div>
  );
};

export default DateView;
